import React, { useCallback, useState } from "react";
import { Box, Grid } from "atoms";

import { SendEmailForm } from "molecules";
import { useAuth } from "contexts/Auth";
import { useNavigate } from "react-router-dom";
import { QUERY_PARAMS_ITEMS } from "utils/constants";

const SendEmail = () => {
  const {
    actions: { forgotPassword },
  } = useAuth();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = useCallback(
    async ({ email }) => {
      setLoading(true);
      forgotPassword(email)
        .then((success) => {
          success &&
            navigate({
              pathname: "/otp",
              search: `?${new URLSearchParams({
                [QUERY_PARAMS_ITEMS.workflow]: [
                  QUERY_PARAMS_ITEMS.isResetPassword,
                ],
              })}`,
            });
        })
        .catch((e) => {
          setError(e?.message);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [forgotPassword, navigate]
  );

  return (
    <Box h="100vh">
      <Grid aI="center" h="100vh" px="12rem">
        <SendEmailForm
          onSubmit={onSubmit}
          loading={loading}
          error={error}
          resetError={() => setError("")}
        />
      </Grid>
    </Box>
  );
};

export default SendEmail;
